import { render, staticRenderFns } from "./PollChoiceListEditorItemFileUploader.vue?vue&type=template&id=c1f662d4&scoped=true"
import script from "./PollChoiceListEditorItemFileUploader.vue?vue&type=script&lang=js"
export * from "./PollChoiceListEditorItemFileUploader.vue?vue&type=script&lang=js"
import style0 from "./PollChoiceListEditorItemFileUploader.vue?vue&type=style&index=0&id=c1f662d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1f662d4",
  null
  
)

export default component.exports